import React from 'react';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const ColumnFilter = ({
  filterConfig,
  value,
  onChange,
  options = [],
  loading = false,
}) => {
  const { key, label, filterType, placeholder } = filterConfig;

  const renderFilter = () => {
    switch (filterType) {
      case 'select':
        return (
          <FormControl
            size='small'
            sx={{
              flex: '1 1 160px',
              minWidth: 120,
              '& .MuiInputLabel-root': { fontSize: '0.875rem' },
              '& .MuiSelect-select': { fontSize: '0.875rem' },
              '& .MuiInputBase-root': { fontSize: '0.875rem' },
            }}>
            <InputLabel size='small'>{label}</InputLabel>
            <Select
              size='small'
              value={value || ''}
              onChange={(e) => onChange(key, e.target.value)}
              label={label}
              disabled={loading}>
              {loading ? (
                <MenuItem disabled>
                  <CircularProgress size={16} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : (
                options.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: '0.875rem' }}>
                    {option.label}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        );

      case 'search':
        return (
          <TextField
            size='small'
            placeholder={placeholder || `Search ${label}...`}
            value={value || ''}
            onChange={(e) => onChange(key, e.target.value)}
            sx={{
              flex: '2 1 220px',
              minWidth: 200,
              '& .MuiInputBase-input': { fontSize: '0.875rem' },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon fontSize='small' />
                </InputAdornment>
              ),
            }}
          />
        );

      default:
        console.warn(`Unknown filter type: ${filterType}`);
        return null;
    }
  };

  return renderFilter();
};

export default ColumnFilter;
